import { RcThemeInput } from '@ringcentral/juno';
import { overridesFactory } from '@/shared/theme/utils/overrides.factory';
import { paletteFactory } from '@/shared/theme/utils/palette.factory';

export const telusColor = '#2B8000';

export const telusTheme: RcThemeInput = {
  palette: paletteFactory(telusColor),
  overrides: overridesFactory(telusColor),
};
